import { RolesAndPermissions } from '@shared/constants/roles-and-permissions';
import { VtSettingsListGroupLink } from '@shared/interfaces/settings-list-group-link';
import { AccessControlSettingsRouteName } from '@pages/settings-page/settings-route-names';

export const accessControlMenuItemTitle = 'Settings.Access.Control';
export const accessControlMenuItemLinks: VtSettingsListGroupLink[] = [
  {
    label: 'Settings.Access.Control.Roles',
    routerLink: AccessControlSettingsRouteName.Roles,
    permissions: [RolesAndPermissions.RoleSettingsRead],
  },
  {
    label: 'Settings.Access.Control.Permissions',
    routerLink: AccessControlSettingsRouteName.Permissions,
  },
  {
    label: 'Settings.Access.Control.UserLog',
    routerLink: AccessControlSettingsRouteName.UserLog,
    permissions: [RolesAndPermissions.UserLogSettingsRead],
  },
  // {
  //   label: 'Settings.Access.Control.PermissionLog',
  //   routerLink: AccessControlSettingsRouteName.PermissionLog,
  //   permissions: [RolesAndPermissions.RoleSettingsRead],
  // },
];
